<div class="searcher-header">
  {{ 'documents.editor.findAndReplace' | translate }}

  <button class="btn-M btn-text icon-only searcher-button--type-close" (click)="closeModal()">
    <i class="fal fa-xmark"></i>
  </button>
</div>

<div>
  <input class="searcher-input" #searchInput id="search-input" type="text" (keyup)="keyPressedHandler($event)" [placeholder]="'documents.editor.find' | translate" [value]="textToSearch" />
  <input class="searcher-input" #replaceInput id="replace-input" type="text" [placeholder]="'documents.editor.replaceWith' | translate" />
</div>

<div class="searcher-container_middle">
  <label class="searcher-case"> <app-switch id="caseSensitive" (change)="toggleCaseSensitive()"></app-switch> {{ 'documents.editor.differentiateCases' | translate }} </label>

  <div class="searcher-navigate">
    @if (editor?.storage?.findAndReplace?.results.length > 0) {
      <div class="searcher-count">({{ editor.storage.findAndReplace?.resultIndex + 1 }} / {{ editor.storage.findAndReplace?.results.length }})</div>
    }

    <button (keydown)="handleKeydown($event, SearchAction.Prev)" (click)="prevOccurance()" class="btn-M btn-filled-cancel icon-only">
      <i class="fa-solid fa-chevron-up"></i>
    </button>
    <button (keydown)="handleKeydown($event, SearchAction.Next)" (click)="nextOccurance()" class="btn-M btn-filled-cancel icon-only">
      <i class="fa-solid fa-chevron-down"></i>
    </button>
  </div>
</div>

<div class="searcher-button__box">
  <button (keydown)="handleKeydown($event, SearchAction.Find)" (click)="search()" class="btn-M btn-filled">{{ 'documents.editor.find' | translate }}</button>

  <div>
    <button (keydown)="handleKeydown($event, SearchAction.Replace)" (click)="replace()" class="btn-M btn-filled-cancel">{{ 'documents.editor.replace' | translate }}</button>
    <button (keydown)="handleKeydown($event, SearchAction.ReplaceAll)" (click)="replaceAll()" class="btn-M btn-filled-cancel">
      {{ 'documents.editor.replaceAll' | translate }}
    </button>
  </div>
</div>
